;
define("itemssearcher.tpl", function(){});

